/**
 * 受注一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/unassigned_anytime_orders`

const allocation_unassigned_anytime_order = {
  namespaced: true,
  actions: {
    /**
     * 配車計画 日付未定受注一覧
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}

export default allocation_unassigned_anytime_order
